export const PROMO_QUALIFIER_FIELDS = [
  { key: 'qualifier_2', label: 'Atributo A' },
  { key: 'qualifier_3', label: 'Atributo B' },
  { key: 'qualifier_4', label: 'Atributo C' },
  { key: 'qualifier_5', label: 'Atributo D' },
  { key: 'qualifier_6', label: 'Atributo E' }
]

export const PROMO_EMPTY_QUALIFIERS = Object.fromEntries(
  PROMO_QUALIFIER_FIELDS.map(({ key }) => [key, []])
)

export const PROMO_EMPTY_SELECTED_QUALIFIERS = Object.fromEntries(
  PROMO_QUALIFIER_FIELDS.map(({ key }) => [key, []])
)

export const PROMO_CLIENT_ATTRIBUTE_FILTER_KEYS = [
  'Cliente individual',
  ...PROMO_QUALIFIER_FIELDS.map(({ label }) => label)
]

export const PROMO_INDEX_FILTERS_DIC = {
  Estado: 'status',
  'Tipo de promoción': 'promo_type',
  'PRODUCTO(S)/MARCA': 'products',
  'Cliente individual': 'qualifier_1',
  ...Object.fromEntries(PROMO_QUALIFIER_FIELDS.map(({ label, key }) => [label, key]))
}

export const buildAppliesToFromSelectedQualifiers = (selected) =>
  PROMO_QUALIFIER_FIELDS.flatMap(({ key }) => selected[key] || [])

export const hasAnySelectedQualifier = (selected) =>
  PROMO_QUALIFIER_FIELDS.some(({ key }) => (selected[key] || []).length > 0)

export const formatPromoQualifiersDisplay = (model) =>
  PROMO_QUALIFIER_FIELDS.filter(({ key }) => model[key]?.length > 0).map(
    ({ key, label }) => `${label} - ${model[key].join(', ')}`
  )

export const buildDefaultClientQualifierDic = () => [
  { key: 'Cliente individual', value: [] },
  ...PROMO_QUALIFIER_FIELDS.map(({ label }) => ({ key: label, value: [] }))
]

export const buildClientQualifierDicFromFilterData = (data, clients) => [
  { key: 'Cliente individual', value: clients?.map((c) => c.name) ?? [] },
  ...PROMO_QUALIFIER_FIELDS.map(({ label, key }) => ({
    key: label,
    value: data[key] ?? []
  }))
]
